var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
/**
 * Used to display git information on staging servers
 */
var GitInfo = function (_a) {
    var gitInfo = _a.gitInfo;
    var _b = __read(useState(false), 2), isClosed = _b[0], setIsClosed = _b[1];
    var hostname = window.location.hostname.split(".").slice(-2).join(".");
    if ((hostname !== "localhost" && hostname !== "say.rocks") || isClosed) {
        return null;
    }
    return (_jsx(Box, __assign({ "data-testid": "gitinfo", sx: {
            position: "fixed",
            background: "rgba(0,0,0,0.3)",
            color: "white",
            bottom: 0,
            left: 0,
            p: 2,
            pr: 6,
            zIndex: 100,
        } }, { children: _jsxs(Box, { children: [_jsx(Box, __assign({ sx: {
                        position: "absolute",
                        top: -3,
                        right: -3,
                    } }, { children: _jsx(IconButton, __assign({ onClick: function () { return setIsClosed(true); }, size: "small" }, { children: _jsx(CloseIcon, { fontSize: "small" }) })) })), _jsxs("p", { children: [_jsx("strong", { children: "Git Branch:" }), " ", _jsx("code", { children: gitInfo.gitBranch })] }), _jsxs("p", { children: [_jsx("strong", { children: "Git Commit Hash:" }), " ", _jsx("code", { children: gitInfo.gitCommitHash })] })] }) })));
};
export default GitInfo;
